'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/shop/BasketIcon.tsx
import { jsx } from "react/jsx-runtime";
var BasketIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.06055 3H19.9394L21.0644 21H2.93555L4.06055 3ZM5.93945 5L5.06445 19H18.9355L18.0605 5H5.93945ZM10 7V8C10 9.10457 10.8954 10 12 10C13.1046 10 14 9.10457 14 8V7H16V8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8V7H10Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/shop/CartIcon.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var CartIcon = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5 15.8327C5 14.9122 5.74619 14.166 6.66667 14.166C7.58714 14.166 8.33333 14.9122 8.33333 15.8327C8.33333 16.7532 7.58714 17.4993 6.66667 17.4993C5.74619 17.4993 5 16.7532 5 15.8327ZM12.5 15.8327C12.5 14.9122 13.2462 14.166 14.1667 14.166C15.0871 14.166 15.8333 14.9122 15.8333 15.8327C15.8333 16.7532 15.0871 17.4993 14.1667 17.4993C13.2462 17.4993 12.5 16.7532 12.5 15.8327Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.833984 1.66602H4.03992L5.70659 11.666H15.5447L16.8157 4.04035L18.4596 4.31435L16.9566 13.3327H4.29471L2.62805 3.33268H0.833984V1.66602Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.6667 2.5V5H14.1667V6.66667H11.6667V9.16667H10V6.66667H7.5V5H10V2.5H11.6667Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

// src/shop/ShopIcon.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var ShopIcon = (props) => {
  return /* @__PURE__ */ jsx3(
    "svg",
    __spreadProps(__spreadValues({
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx3(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.8 5.1C8.08328 4.72229 8.52786 4.5 9 4.5H27C27.4721 4.5 27.9167 4.72229 28.2 5.1L32.7 11.1C32.8947 11.3596 33 11.6754 33 12V13.5C33 15.0216 32.4322 16.412 31.5 17.4686V30C31.5 30.8284 30.8284 31.5 30 31.5H6C5.17157 31.5 4.5 30.8284 4.5 30V17.4686C3.56777 16.412 3 15.0216 3 13.5V12C3 11.6754 3.10527 11.3596 3.3 11.1L7.8 5.1ZM7.5 19.3107V28.5H13.5L13.5 25.5C13.5 23.0147 15.5147 21 18 21C20.4853 21 22.5 23.0147 22.5 25.5L22.5 28.5H28.5V19.3107C28.0204 19.4342 27.5177 19.5 27 19.5C25.208 19.5 23.5994 18.7144 22.5 17.4687C21.4006 18.7144 19.792 19.5 18 19.5C16.208 19.5 14.5994 18.7144 13.5 17.4687C12.4006 18.7144 10.792 19.5 9 19.5C8.48234 19.5 7.97963 19.4342 7.5 19.3107ZM15 13.5C15 15.1569 16.3431 16.5 18 16.5C19.6569 16.5 21 15.1569 21 13.5H15ZM7.5 10.5L9.75 7.5H26.25L28.5 10.5H7.5ZM24 13.5C24 15.1569 25.3431 16.5 27 16.5C27.7693 16.5 28.4679 16.2124 28.9996 15.7365C29.6158 15.185 30 14.3884 30 13.5H24ZM6 13.5H12C12 15.1569 10.6569 16.5 9 16.5C8.23069 16.5 7.53212 16.2124 7.00037 15.7365C6.38422 15.185 6 14.3884 6 13.5ZM19.5 28.5L19.5 25.5C19.5 24.6716 18.8284 24 18 24C17.1716 24 16.5 24.6716 16.5 25.5L16.5 28.5H19.5Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  BasketIcon,
  CartIcon,
  ShopIcon
};
//# sourceMappingURL=chunk-E2PVZWPT.mjs.map